// Function to parse all cookies into an object
const parseCookies = () =>
  Object.fromEntries(document.cookie.split('; ').map(c => {
    const [key, ...val] = c.split('=');
    return [key, val.join('=')]; // Join the value in case it contains '='
  }));

// Function to get Google Client ID (_ga cookie)
const getClientId = () => {
  const cookies = parseCookies();
  return cookies["_ga"] ? cookies["_ga"].substring(6) : null;
};

// Function to get Google Client ID (_ga cookie)
const getRefUrl = () => {
  const cookies = parseCookies();
  return cookies["utm_ref"] ? cookies["utm_ref"] : window.location.href;
};

// Function to get UTM parameters from __utmzz cookie
const getUtms = () => {
  const cookies = parseCookies();
  if (!cookies['__utmzz']) return {}; // Return an empty object if __utmzz is not found

  return Object.fromEntries(
    cookies['__utmzz'].split('|').map(el => {
      const [key, value] = el.split('=');
      return [key.trim(), value];
    })
  );
};

function getUtmsData() {
  const utms = getUtms()
  const utmData = {
    UtmSource: utms['utmcsr'] || '',
    UtmMedium: utms['utmcmd'] || '',
    UtmCampaign: utms['utmccn'] || '',
    UtmContent: utms['utmcct'] || '',
    UtmTerm: utms['utmctr'] || '',
    GoogleClientId: getClientId(),
    Url: getRefUrl(),
  };
  return utmData;
}
// Sending data via POST request
export async function sendClientDataByPost(clientId, entity) {
  const utmData = getUtmsData();
  const clientData = {
    ClientId: clientId,
    Entity: entity,
  };

  const requestData = { ...clientData, ...utmData };

  try {
    const response = await fetch('https://fa-ga-sync.azurewebsites.net/api/ga/client', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    // Check if the response is successful
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json(); // Return server response if needed
  } catch (error) {
    console.error('Error:', error);
  }
}

// Sending data via GET request
export async function sendClientData(clientId, entity) {
  const utmData = getUtmsData();
  const clientData = {
    ClientId: clientId,
    Entity: entity,
  };

  // Construct URL with query parameters
  const params = new URLSearchParams({ ...clientData, ...utmData }).toString();
  const url = `https://fa-ga-sync.azurewebsites.net/api/ga/client?${params}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Check if the response is successful
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json(); // Return server response if needed
  } catch (error) {
    console.error('Error:', error);
  }
}



// WEBPACK FOOTER //
// ./src/util/ga.js